import React from 'react';

const LoadingIndicator = (props) => {
  const { message = 'Loading more leads...' } = props;
  return (
    <div className="loading-indicator">
      <div className="loading-spinner"></div>
      <span className="load-more-msg">{message}</span>
    </div>
  );
};

export default React.memo(LoadingIndicator);
